var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5845 4H8.41533C5.98072 4 4 5.98081 4 8.41542V15.5846C4 18.0193 5.98072 20 8.41533 20H15.5845C18.0193 20 20 18.0192 20 15.5846V8.41542C20.0001 5.98081 18.0193 4 15.5845 4ZM18.5805 15.5846C18.5805 17.2365 17.2365 18.5804 15.5846 18.5804H8.41533C6.76348 18.5805 5.4196 17.2365 5.4196 15.5846V8.41542C5.4196 6.76358 6.76348 5.4196 8.41533 5.4196H15.5845C17.2364 5.4196 18.5804 6.76358 18.5804 8.41542V15.5846H18.5805Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.87739C9.72666 7.87739 7.8772 9.72685 7.8772 12.0002C7.8772 14.2734 9.72666 16.1228 12 16.1228C14.2733 16.1228 16.1228 14.2734 16.1228 12.0002C16.1228 9.72685 14.2733 7.87739 12 7.87739ZM12 14.7031C10.5095 14.7031 9.2968 13.4906 9.2968 12.0001C9.2968 10.5095 10.5094 9.2969 12 9.2969C13.4906 9.2969 14.7032 10.5095 14.7032 12.0001C14.7032 13.4906 13.4905 14.7031 12 14.7031Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2957 6.67367C16.0222 6.67367 15.7535 6.7844 15.5604 6.97841C15.3662 7.17148 15.2547 7.44025 15.2547 7.71471C15.2547 7.98831 15.3663 8.25699 15.5604 8.45101C15.7534 8.64407 16.0222 8.75575 16.2957 8.75575C16.5702 8.75575 16.838 8.64407 17.032 8.45101C17.226 8.25699 17.3367 7.98822 17.3367 7.71471C17.3367 7.44025 17.226 7.17148 17.032 6.97841C16.8389 6.7844 16.5702 6.67367 16.2957 6.67367Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.afaea452.svg";
export { ForwardRef as ReactComponent };